import { clsx } from 'clsx'
import { Segment } from 'component/Space/Segment'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import FemaleApple from 'page/ProfileScreen/assets/female-apple.svg'
import FemaleHourglass from 'page/ProfileScreen/assets/female-hourglass.svg'
import FemalePear from 'page/ProfileScreen/assets/female-pear.svg'
import FemaleRectangle from 'page/ProfileScreen/assets/female-rectangle.svg'
import FemaleTriangle from 'page/ProfileScreen/assets/female-triangle.svg'
import MaleInvertedTriangle from 'page/ProfileScreen/assets/male-inverted triangle.svg'
import MaleOval from 'page/ProfileScreen/assets/male-oval.svg'
import MaleRectangle from 'page/ProfileScreen/assets/male-rectangle.svg'
import MaleTriangle from 'page/ProfileScreen/assets/male-triangle.svg'
import { FC, SVGProps } from 'react'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { ShapeType } from 'type/Identity'
import css from './Shape.module.scss'

type Props = {
  type: ShapeType
}

function getSvg(type: ShapeType): FC<SVGProps<any>> | undefined {
  const { gender } = store.profile
  const male = gender === 'male'

  if (type === 'apple') return FemaleApple
  if (type === 'hourglass') return FemaleHourglass
  if (type === 'inverted triangle') return MaleInvertedTriangle
  if (type === 'oval') return MaleOval
  if (type === 'pear') return FemalePear
  if (type === 'rectangle') return male ? MaleRectangle : FemaleRectangle
  if (type === 'triangle') return male ? MaleTriangle : FemaleTriangle
}

export const Shape = observer(({ type }: Props) => {
  const { form } = store.profile
  const Svg = getSvg(type)
  const isActive = form.shape === type
  const className = clsx(css.shape, isActive && css.active, opt.tsum && css.tsum)

  const onClick = useLatestCallback(() => {
    form.setShape(type)
  })

  return <Segment fill={opt.tsum} height={opt.stand ? 96 : 64} active={isActive} action={onClick}>
    {Svg && <Svg height={opt.stand ? 84 : 56} width={32} className={className} />}
  </Segment>
})
